import http from '@/libs/AxiosPlugin'

const user = {
  login (username, password, systemCode) {
    return http.post('/login', { username, password, systemCode })
  },

  fetchUserInfo () {
    // return Promise.resolve({
    //   user: {
    //     username: 'admin',
    //     name: 'DaviaLi',
    //     workNo: '7713',
    //     department: '研发部',
    //     workPosition: '工程师',
    //     role: '管理员',
    //     phone: '13800138000',
    //     eMail: '11111@qq.com',
    //     qq: '11111',
    //     wechat: 'wechat1111'
    //   },
    //   company: { name: '心恬电子', lang: 'zh' },
    //   permissions: []
    // })

    return http.get('/fetchUserInfo')
  },

  changePw (oldPassword, newPassword) {
    return http.post('/changePw', { oldPassword, newPassword })
  }
}

export default user



// WEBPACK FOOTER //
// ./src/api/user.js